import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  REQUEST_PASSWORD_RESET_EMAIL,
  REQUEST_PASSWORD_RESET_EMAIL_SUCCESS,
  REQUEST_PASSWORD_RESET_EMAIL_FAILED,
} from '../../constants';

const requestPasswordResetEmail = (action$, state$) =>
  action$.pipe(
    ofType(REQUEST_PASSWORD_RESET_EMAIL),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/password-reset?v=${process.env.REACT_APP_VERSION}`,
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {

          return {
            type: REQUEST_PASSWORD_RESET_EMAIL_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: REQUEST_PASSWORD_RESET_EMAIL_FAILED,
            error,
          })
        )
      )
    )
  );

export default requestPasswordResetEmail;
